import React from 'react';
import { Form } from 'react-bootstrap';
import TableData from '../../../../../_components/TableData';
import { formatCurrencyValue } from '../../../../../utils';
import Text from '../../../../../_components/Text';

const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const parts = dateStr.split('-');
    if (parts.length === 3) {
        return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
    return dateStr;
};

export default function OpenFinanceTable({ data, categories, onUpdateCategory, onDeleteTransaction, isPreview }) {
    if (!data || data.length === 0) {
        return (
            <div className="text-center py-5 text-muted bg-light">
                <i className="fas fa-history fa-3x mb-3 opacity-50" />
                <p className="mb-0">Nenhum registro encontrado para este filtro.</p>
            </div>
        );
    }

    // Flatten categories for the select dropdown
    const flatCategories = [];
    const flatten = (items, level = 0) => {
        if (!items) return;
        items.forEach(cat => {
            flatCategories.push({ ...cat, label: `${"- ".repeat(level)}${cat.name}`, level });
            if (cat.children && cat.children.length > 0) {
                flatten(cat.children, level + 1);
            }
        });
    };
    flatten(categories || []);

    const mapped = data.map((item, i) => ({
        idx: <Text className="small">{i + 1}</Text>,
        date: <Text className="font-weight-bold">{formatDate(item.date)}</Text>,
        description: <Text title={item.description} className="text-truncate" style={{ maxWidth: '300px' }}>{item.description}</Text>,
        amount: (
            <Text className={`font-weight-bold ${item.transaction_type === 'C' ? 'text-success' : 'text-danger'}`}>
                {item.transaction_type === 'D' ? '- ' : '+ '}
                {formatCurrencyValue(Math.abs(item.amount))}
            </Text>
        ),
        type: (
            <div className={`d-flex flex-column ${item.transaction_type === 'C' ? 'text-success' : 'text-danger'}`}>
                <Text className="font-weight-bold mb-0" style={{ fontSize: '11px' }}>
                    <i className={`fas ${item.transaction_type === 'C' ? 'fa-arrow-up' : 'fa-arrow-down'} mr-1`} />
                    {item.entry_type || (item.transaction_type === 'C' ? 'CRÉDITO' : 'DÉBITO')}
                </Text>
                <Text className="opacity-75" style={{ fontSize: '9px' }}>
                    {item.transaction_type === 'C' ? 'Entrada' : 'Saída'}
                </Text>
            </div>
        ),
        category: isPreview ? (
            <Text className="text-muted small">Aguardando Importação</Text>
        ) : (
            <div className="d-flex flex-column" style={{ minWidth: '200px' }}>
                <Form.Control
                    as="select"
                    size="sm"
                    className="mb-1 border-0 bg-light"
                    value={item.category_id || ""}
                    onChange={e => onUpdateCategory(item.id, e.target.value)}
                    style={{ fontSize: '12px', height: '30px' }}
                >
                    <option value="">Selecionar Categoria...</option>
                    {flatCategories.map(cat => (
                        <option key={cat.id} value={cat.id}>{cat.label}</option>
                    ))}
                </Form.Control>
                {item.ai_suggestion && !item.category_id && (
                    <Text className="text-warning font-weight-bold" style={{ fontSize: '10px' }}>
                        <i className="fas fa-robot mr-1" /> Sugestão IA: {item.ai_suggestion}
                    </Text>
                )}
            </div>
        ),
        status: (
            <div className="d-flex align-items-center">
                {item.category_id ? (
                    <span className="badge badge-success-light text-success p-1 small" style={{ fontSize: '10px' }}>
                        <i className="fas fa-check-circle mr-1" /> Conciliado
                    </span>
                ) : (
                    <span className={`badge ${isPreview ? 'badge-secondary' : 'badge-warning-light text-warning'} p-1 small`} style={{ fontSize: '10px' }}>
                        <i className={`${isPreview ? 'fas fa-clock' : 'fas fa-exclamation-triangle'} mr-1`} />
                        {isPreview ? 'Pendente' : 'Não Conciliado'}
                    </span>
                )}
            </div>
        ),
        actions: !isPreview && (
            <div className="text-center">
                <i
                    className="fas fa-trash-alt text-danger cursor-pointer p-2"
                    title="Excluir lançamento"
                    onClick={() => {
                        if (window.confirm("Deseja realmente remover esta transação do histórico?")) {
                            onDeleteTransaction(item.id);
                        }
                    }}
                    style={{ cursor: 'pointer' }}
                />
            </div>
        )
    }));

    return (
        <div className="table-responsive bg-white rounded shadow-sm border">
            <TableData
                tHead={['#', 'Data da Transação', 'Descrição', 'Valor', 'Tipo', 'Categoria', 'Status', 'Ações']}
                data={mapped}
                tBodyKeys={['idx', 'date', 'description', 'amount', 'type', 'category', 'status', 'actions']}
            />
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Financial/OpenFinance/components/OpenFinanceTable.jsx